import { rem } from 'polished'
import styled from 'styled-components'

import { CruiseContentSections } from 'constants/cruise'
import useCruiseContentSectionLabels from 'hooks/Cruise/useCruiseContentSectionLabels'
import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import Heading from 'LuxKit/Typography/Heading'
import CruiseItineraryAndMap from './CruiseItineraryAndMap'
import Group from 'components/utils/Group'

const SectionContainer = styled.div`
  padding: ${rem(32)} 0;
`

interface Props {
  itinerary?: Array<App.CruiseItineraryItem>
  cruiseType: App.CruiseType
}

function CruiseOfferPageItinerary({
  itinerary,
  cruiseType,
}: Props) {
  const sectionLabels = useCruiseContentSectionLabels()

  return <Pane>
    <LayoutContainer>
      <SectionContainer>
        <Group direction="vertical" gap={32}>
          <Heading
            align="center"
            variant="heading2"
            className="section-title"
          >
            {sectionLabels[CruiseContentSections.ITINERARY]}
          </Heading>
          <div className="section-content">
            {itinerary && <CruiseItineraryAndMap itinerary={itinerary} cruiseType={cruiseType} />}
          </div>
        </Group>
      </SectionContainer>
    </LayoutContainer>
  </Pane>
}

export default CruiseOfferPageItinerary
